// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3OqXw","text":"SelectPayment_text__yrOPV","title":"SelectPayment_title__2bkQs","btn":"SelectPayment_btn__1nzqx"};